import type { PortraitCustomCategory, PortraitGrade, PortraitHomeroom } from '@/api/types/portrait'
import type { PortraitFilterOption } from '../types/portrait-filter-option'

/** A grade as a dropdown choice: filter by its id, show its name. */
export function gradeToOption(grade: PortraitGrade): PortraitFilterOption {
  return { value: grade.gradeId, label: grade.gradeName }
}

/** A homeroom as a dropdown choice: filter by its id, show its name. */
export function homeroomToOption(homeroom: PortraitHomeroom): PortraitFilterOption {
  return { value: homeroom.homeroomId, label: homeroom.homeroomName }
}

/** A custom group as a dropdown choice: filter by its id, show its name. Names are not unique. */
export function customCategoryToOption(category: PortraitCustomCategory): PortraitFilterOption {
  return { value: category.customCategoryId, label: category.customCategoryName }
}
